import MDButton from 'components/MDButton'
import React, { useEffect, useState } from 'react'
import MDModal from 'components/MDModal'
import MDBox from 'components/MDBox'
import MDTypography from 'components/MDTypography'
import './index.css'
import {
  Button,
  Checkbox,
  FormControlLabel,
  FormGroup,
  Stack,
  Switch,
  TextareaAutosize,
} from '@mui/material'
import { useAppServices, useUploadImage } from 'hook/services'
import { useUserInfo } from 'context/user'
import MDInput from 'components/MDInput'
import Multiselect from '../CreateModal/components/Multiselect'
const style = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  width: 400,
  height: '80vh',
  overflow: 'auto',
  bgcolor: 'background.paper',
  border: '2px  #000',
  boxShadow: 24,
  p: 4,
}
const EditModal = ({
  data,
  handleRefresh,
  Categories,
  Types,
  Tags,
  Dash_tags,
  business_types,
  staff,
}) => {
  const uploadImage = useUploadImage()
  const [openAddProduct, setOpenAddProduct] = useState(false)
  const AppService = useAppServices()
  const [user] = useUserInfo()
  const staffOptions = staff?.map((item) => ({
    label: item?.username,
    value: item?._id,
  }))

  const types = [
    {
      label: 'Agency',
      value: 'agency',
    },
    {
      label: 'Subaccount',
      value: 'sub_account',
    },
    {
      label: 'Agency & Subaccount',
      value: 'both',
    },
  ]

  const integration_type = [
    {
      label: 'Basic',
      value: 'basic',
    },
    {
      label: 'Iframe',
      value: 'iframe',
    },
    {
      label: 'Url',
      value: 'url',
    },
    {
      label: 'Form',
      value: 'form',
    },
  ]

  const roadmapStatus = [
    {
      label: 'Wish List',
      value: 'wish-list',
    },
    {
      label: 'Planned',
      value: 'planned',
    },
    {
      label: 'In Progress',
      value: 'in-progress',
    },
    {
      label: 'Testing (Beta)',
      value: 'testing',
    },
    {
      label: 'Completed',
      value: 'completed',
    },
  ]

  const status = [
    {
      label: 'Active',
      value: 'active',
    },
    {
      label: 'Inactive',
      value: 'inactive',
    },
    {
      label: 'Beta',
      value: 'beta',
    },
  ]
  const SubscriptionTypes = [
    {
      label: 'Free',
      value: 'free',
    },
    {
      label: 'Paid',
      value: 'paid',
    },
    {
      label: 'Unlimited',
      value: 'unlimited',
    },
  ]
  const timeline = [
    {
      label: '7 Days',
      value: '7 days',
    },
    {
      label: '14 Days',
      value: '14 days',
    },
    {
      label: '30 Days',
      value: '30 days',
    },
    {
      label: '60 Days',
      value: '60 days',
    },
    {
      label: '90 Days',
      value: '90 days',
    },
  ]
  const FeaturesList = [
    {
      label: 'Snapshot',
      value: 'snapshot',
    },
    {
      label: 'Widget',
      value: 'widget',
    },
    {
      label: 'Custom Js',
      value: 'custom_js',
    },
    {
      label: 'Payment Provider',
      value: 'payment_provider',
    },
    {
      label: 'Actions',
      value: 'actions',
    },
    {
      label: 'Triggers',
      value: 'triggers',
    },
    {
      label: 'Conversation Providers',
      value: 'conversation_providers',
    },
  ]
  const handlemodal = () => {
    setOpenAddProduct(true)
  }
  useEffect(async () => {}, [])
  function AddProduct({ open, onClose }) {
    const [processing, setProcessing] = useState(false)
    const [goingToLive, setGoingToLive] = useState(data?.status !== 'inactive')

    const handleCheckboxChange = (event) => {
      setGoingToLive(event.target.checked)
    }

    const handleSubmit = async (e) => {
      e.preventDefault()

      if (
        goingToLive &&
        !e.target?.app_id?.value &&
        !e.target?.client_id?.value &&
        !e.target?.client_secret?.value &&
        !e.target?.sso?.value
      ) {
        alert('Please must add required inputs to make the app publish')
        return false
      }
      setProcessing(true)

      const app_type = JSON.parse(e.target.app_type.value).value
      var image_response = data.image
      console.log(
        'e.target?.image?.files?.[0] && goingToLive',
        e.target?.image?.files?.[0],
        goingToLive
      )
      if (e.target?.image?.files?.[0] && goingToLive) {
        var response_data = await uploadImage({
          file: e.target.image.files[0],
          desiredPath: `app/logo/image`,
        })
        if (response_data.response) {
          image_response = response_data.response.data
        }
      }

      const payload = {
        _id: data._id,
        name: e.target.name.value,
        app_id: e.target?.app_id?.value,
        staff: e.target.staff ? JSON.parse(e.target.staff.value) : [],

        video_url: e.target.video_url.value,
        client_id: e.target?.client_id?.value,
        client_secret: e.target?.client_secret?.value,
        description: e.target.description.value,
        app_triggers: e.target.app_triggers.checked,
        hasUIInterface: e.target.hasUIInterface.checked,
        default_app: e.target.default_app.checked,
        ghl_add_on: e.target.ghl_add_on.checked,

        location_tool: e.target.location_tool.checked,
        nav_icon: e.target.nav_icon?.value,

        sso: e.target?.sso?.value,
        categories: e.target.categories.value ? JSON.parse(e.target.categories.value) : '',
        app_features: e.target.app_features.value ? JSON.parse(e.target.app_features.value) : '',
        app_subscription_type: e.target.app_subscription_type.value
          ? JSON.parse(e.target.app_subscription_type.value)
          : '',
        app_type: e.target.app_type.value ? JSON.parse(e.target.app_type.value) : '',
        status: e.target.status.value ? JSON.parse(e.target.status.value) : '',
        roadmap_status: e.target.roadmap_status.value
          ? JSON.parse(e.target.roadmap_status.value)
          : '',
        distinguish_type:
          e.target.distinguish_type && e.target.distinguish_type.value
            ? JSON.parse(e.target.distinguish_type.value)
            : {},

        business_type:
          e.target.business_type && e.target.business_type.value
            ? JSON.parse(e.target.business_type.value)
            : {},
        tags:
          e.target.tags && e.target.tags.value && e.target.tags.value?.length
            ? JSON.parse(e.target.tags.value)
            : [],
        dash_tags:
          e.target.dash_tags && e.target.dash_tags.value && e.target.dash_tags.value?.length
            ? JSON.parse(e.target.dash_tags.value)
            : [],
        image: image_response,
        user_id: user._id,
        url: e.target.url.value,
        custom_page: e.target.custom_page.value,
        agency_custom_page: e.target.agency_custom_page.value,
        ghlLocations_enable: app_type == 'agency' ? e.target.ghlLocations_enable.checked : false,
        ghlusers_enable: app_type == 'agency' ? e.target.ghlusers_enable.checked : false,
        location_modal_key:
          app_type == 'agency' && e.target.ghlLocations_enable.checked == true
            ? e.target.location_modal_key.value
            : null,
        location_auth:
          app_type == 'agency' && e.target.ghlLocations_enable.checked == true
            ? e.target.location_auth.checked
            : null,
        user_modal_key:
          app_type == 'agency' && e.target.ghlusers_enable.checked == true
            ? e.target.user_modal_key.value
            : null,
        is_blackBox: e.target.is_blackBox.checked,
        dont_show: e.target.dont_show.checked,
        dont_show_location: e.target.dont_show_location.checked,
        included_all_the_apps: e.target.included_all_the_apps.checked,
      }

      const { response } = await AppService.app.update({
        payload: payload,
      })
      // console.log(response)
      if (response) {
        setProcessing(false)
        onClose()
        // handleRefresh()
      }
    }
    function IN() {
      const [integrationValue, setIntegrationValue] = useState(data?.integrationType?.value)
      return (
        <>
          <MDBox sx={{ fontSize: '15px' }}>
            <MDTypography variant="button" sx={{ fontSize: '14px', fontWeight: '500' }} mb={1}>
              Integration Type
            </MDTypography>
            <Multiselect
              data={integration_type}
              edit_data={data.integrationType}
              isMulti={false}
              name="integration_type"
              onChange={setIntegrationValue}
            />
          </MDBox>
          {integrationValue == 'auth' && (
            <MDBox>
              <MDTypography variant="button" sx={{ fontSize: '14px', fontWeight: '500' }} mb={1}>
                Route
              </MDTypography>
              <MDInput label="Route" defaultValue={data?.route} name="route" fullWidth />
            </MDBox>
          )}
          {integrationValue == 'iframe' && (
            <MDBox>
              <MDTypography variant="button" sx={{ fontSize: '14px', fontWeight: '500' }} mb={1}>
                Iframe
              </MDTypography>
              <MDInput label="Iframe" name="iframe" defaultValue={data?.iframe} fullWidth />
            </MDBox>
          )}
          {integrationValue == 'url' && (
            <MDBox>
              <MDTypography variant="button" sx={{ fontSize: '14px', fontWeight: '500' }} mb={1}>
                url
              </MDTypography>
              <MDInput label="url" name="url" defaultValue={data?.url} fullWidth />
            </MDBox>
          )}
          {integrationValue == 'form' && (
            <MDBox>
              <MDTypography variant="button" sx={{ fontSize: '14px', fontWeight: '500' }} mb={1}>
                url
              </MDTypography>
              <MDInput label="url" name="url" fullWidth defaultValue={data?.url} />
            </MDBox>
          )}
        </>
      )
    }
    function AppType() {
      const [apptype, setApptype] = useState(data?.app_type?.value || '')
      const [ghlLocations_enable, setGhlLocations_enable] = useState(
        data?.ghlLocations_enable || false
      )
      const [ghlusers_enable, setGhlUsers_enable] = useState(data?.ghlusers_enable || false)
      return (
        <>
          <MDBox sx={{ fontSize: '15px' }}>
            <MDTypography variant="button" sx={{ fontSize: '14px', fontWeight: '500' }} mb={1}>
              Type
            </MDTypography>
            <Multiselect
              data={types}
              edit_data={data.app_type}
              isMulti={false}
              name="app_type"
              onChange={setApptype}
            />
          </MDBox>
          {apptype == 'agency' || apptype == 'both' ? (
            <>
              <MDBox>
                <FormControlLabel
                  control={
                    <Switch
                      name="ghlLocations_enable"
                      checked={ghlLocations_enable}
                      onChange={(e) => setGhlLocations_enable(e.target.checked)}
                    />
                  }
                  label="is ghl location is required for this app?"
                />
                {ghlLocations_enable && (
                  <MDBox mt={-1}>
                    <MDBox>
                      <MDTypography
                        variant="button"
                        sx={{ fontSize: '14px', fontWeight: '500' }}
                        mb={1}
                      >
                        Location Modal Key
                      </MDTypography>
                      <MDInput
                        label="Location Modal Key"
                        name="location_modal_key"
                        fullWidth
                        defaultValue={data?.location_modal_key}
                      />
                    </MDBox>
                    <MDBox>
                      <FormControlLabel
                        control={
                          <Checkbox name="location_auth" defaultChecked={data?.location_auth} />
                        }
                        label="is auth tokens required for the locations?"
                      />
                    </MDBox>
                  </MDBox>
                )}
              </MDBox>
              <MDBox>
                <FormControlLabel
                  control={
                    <Switch
                      name="ghlusers_enable"
                      checked={ghlusers_enable}
                      onChange={(e) => setGhlUsers_enable(e.target.checked)}
                    />
                  }
                  label="is ghl user is required for this app?"
                />
                {ghlusers_enable && (
                  <MDBox mt={-1}>
                    <MDTypography
                      variant="button"
                      sx={{ fontSize: '14px', fontWeight: '500' }}
                      mb={1}
                    >
                      User Modal Key
                    </MDTypography>
                    <MDInput
                      label="User Modal Key"
                      name="user_modal_key"
                      fullWidth
                      defaultValue={data?.user_modal_key}
                    />
                  </MDBox>
                )}
              </MDBox>
            </>
          ) : (
            <></>
          )}
        </>
      )
    }
    return (
      <MDModal
        open={open}
        onClose={onClose}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <MDBox>
          <MDBox component="form" onSubmit={handleSubmit} role="form" sx={style}>
            <MDTypography variant="h5" mb={2}>
              Update App
            </MDTypography>
            <MDBox>
              <MDTypography variant="button" sx={{ fontSize: '14px', fontWeight: '500' }} mb={1}>
                Name
              </MDTypography>
              <MDInput label="Name" name="name" fullWidth defaultValue={data?.name} />
            </MDBox>
            <MDBox>
              <MDTypography variant="button" sx={{ fontSize: '14px', fontWeight: '500' }} mb={1}>
                Description
              </MDTypography>
              <MDBox>
                <TextareaAutosize
                  type="text"
                  name="description"
                  defaultValue={data?.description}
                  minRows={3}
                  style={{ width: '100%' }}
                />
              </MDBox>
            </MDBox>
            <MDBox sx={{ fontSize: '15px' }}>
              <MDTypography variant="button" sx={{ fontSize: '14px', fontWeight: '500' }} mb={1}>
                Categories
              </MDTypography>
              <Multiselect
                data={Categories}
                edit_data={data.categories}
                isMulti={true}
                name="categories"
              />
            </MDBox>
            <MDBox sx={{ fontSize: '15px' }}>
              <MDTypography variant="button" sx={{ fontSize: '14px', fontWeight: '500' }} mb={1}>
                Type
              </MDTypography>
              <Multiselect
                data={Types}
                edit_data={data.distinguish_type}
                isMulti={false}
                name="distinguish_type"
              />
            </MDBox>
            <MDBox>
              <MDTypography variant="button" sx={{ fontSize: '14px', fontWeight: '500' }} mb={1}>
                Staff to assign
              </MDTypography>
              <Multiselect data={staffOptions} edit_data={[]} isMulti={true} name="staff" />
            </MDBox>
            <MDBox sx={{ fontSize: '15px' }}>
              <MDTypography variant="button" sx={{ fontSize: '14px', fontWeight: '500' }} mb={1}>
                Business Type
              </MDTypography>
              <Multiselect
                data={business_types}
                edit_data={[]}
                isMulti={true}
                name="business_type"
              />
            </MDBox>
            <MDBox sx={{ fontSize: '15px' }}>
              <MDTypography variant="button" sx={{ fontSize: '14px', fontWeight: '500' }} mb={1}>
                Tags
              </MDTypography>
              <Multiselect data={Tags} edit_data={data?.tags} isMulti={true} name="tags" />
            </MDBox>

            <MDBox sx={{ fontSize: '15px' }}>
              <MDTypography variant="button" sx={{ fontSize: '14px', fontWeight: '500' }} mb={1}>
                Dashboard tags
              </MDTypography>
              <Multiselect
                data={Dash_tags}
                edit_data={data?.dash_tags}
                isMulti={true}
                name="dash_tags"
              />
            </MDBox>
            <MDBox>
              <MDTypography variant="button" sx={{ fontSize: '14px', fontWeight: '500' }} mb={1}>
                Video Url
              </MDTypography>
              <MDInput
                defaultValue={data?.video_url}
                label="Video Url"
                name="video_url"
                fullWidth
              />
            </MDBox>
            <MDBox sx={{ fontSize: '15px' }}>
              <MDTypography variant="button" sx={{ fontSize: '14px', fontWeight: '500' }} mb={1}>
                App Features
              </MDTypography>
              <Multiselect
                data={FeaturesList}
                edit_data={data?.app_features}
                isMulti={true}
                name="app_features"
              />
            </MDBox>
            {AppType()}
            <MDBox sx={{ fontSize: '15px' }}>
              <MDTypography variant="button" sx={{ fontSize: '14px', fontWeight: '500' }} mb={1}>
                App Subscription Type
              </MDTypography>
              <Multiselect
                data={SubscriptionTypes}
                edit_data={data?.app_subscription_type}
                isMulti={false}
                name="app_subscription_type"
              />
            </MDBox>
            <MDBox sx={{ fontSize: '15px' }}>
              <MDTypography variant="button" sx={{ fontSize: '14px', fontWeight: '500' }} mb={1}>
                Status
              </MDTypography>
              <Multiselect data={status} edit_data={data.status} isMulti={false} name="status" />
            </MDBox>
            <MDBox sx={{ fontSize: '15px', marginTop: '10px' }}>
              <MDTypography variant="button" sx={{ fontSize: '14px', fontWeight: '500' }} mb={1}>
                Roadmap Status
              </MDTypography>
              <Multiselect
                data={roadmapStatus}
                edit_data={data?.roadmap_status}
                isMulti={false}
                name="roadmap_status"
              />
            </MDBox>
            <MDBox>
              <MDTypography variant="button" sx={{ fontSize: '14px', fontWeight: '500' }} mb={1}>
                Form url
              </MDTypography>
              <MDInput defaultValue={data?.url} label="url" name="url" fullWidth />
            </MDBox>
            <MDBox>
              <MDTypography variant="button" sx={{ fontSize: '14px', fontWeight: '500' }} mb={1}>
                Custom Page
              </MDTypography>
              <MDInput
                defaultValue={data?.custom_page}
                label="custom_page"
                name="custom_page"
                fullWidth
              />
            </MDBox>
            <MDBox>
              <MDTypography variant="button" sx={{ fontSize: '14px', fontWeight: '500' }} mb={1}>
                Agency Custom Page
              </MDTypography>
              <MDInput
                defaultValue={data?.agency_custom_page}
                label="agency_custom_page"
                name="agency_custom_page"
                fullWidth
              />
            </MDBox>

            <MDBox>
              <FormGroup>
                <FormControlLabel
                  control={<Checkbox defaultChecked={data?.app_triggers} />}
                  label="Is App Have Triggers"
                  name="app_triggers"
                />
              </FormGroup>
            </MDBox>
            <MDBox>
              <FormGroup>
                <FormControlLabel
                  control={<Checkbox defaultChecked={data?.hasUIInterface} />}
                  label="Is App Have Trigger Interface"
                  name="hasUIInterface"
                />
              </FormGroup>
            </MDBox>
            <MDBox>
              <FormGroup>
                <FormControlLabel
                  control={<Checkbox defaultChecked={data?.default_app} />}
                  label="mark as default alltheapps App"
                  name="default_app"
                />
              </FormGroup>
            </MDBox>
            <MDBox>
              <FormGroup>
                <FormControlLabel
                  control={<Checkbox defaultChecked={data?.ghl_add_on} />}
                  label="mark as ghl add on"
                  name="ghl_add_on"
                />
              </FormGroup>
            </MDBox>
            <MDBox>
              <FormGroup>
                <FormControlLabel
                  control={<Checkbox defaultChecked={data?.location_tool} />}
                  label="mark as location tool alltheapps App"
                  name="location_tool"
                />
              </FormGroup>
            </MDBox>
            {data?.location_tool && (
              <MDBox>
                <MDTypography variant="button" sx={{ fontSize: '14px', fontWeight: '500' }} mb={1}>
                  Nav Icon (dev only)
                </MDTypography>
                <MDInput defaultValue={data?.nav_icon} label="Nav Icon" name="nav_icon" fullWidth />
              </MDBox>
            )}
            <MDBox>
              <FormGroup>
                <FormControlLabel
                  control={<Checkbox defaultChecked={data?.included_all_the_apps} />}
                  label="Is it included in all the apps"
                  name="included_all_the_apps"
                />
              </FormGroup>
            </MDBox>

            <MDBox>
              <FormGroup>
                <FormControlLabel
                  control={<Checkbox defaultChecked={data?.is_blackBox} />}
                  label="Is In Black Box"
                  name="is_blackBox"
                />
              </FormGroup>
            </MDBox>

            <MDBox>
              <FormGroup>
                <FormControlLabel
                  control={<Checkbox defaultChecked={data?.dont_show} />}
                  label="Hide App"
                  name="dont_show"
                />
              </FormGroup>
            </MDBox>

            <MDBox>
              <FormGroup>
                <FormControlLabel
                  control={<Checkbox defaultChecked={data?.dont_show_location} />}
                  label="Hide App from location"
                  name="dont_show_location"
                />
              </FormGroup>
            </MDBox>

            <MDBox>
              <FormGroup>
                <FormControlLabel
                  control={
                    <Checkbox
                      checked={goingToLive}
                      onChange={handleCheckboxChange}
                      name="is_going_to_live"
                    />
                  }
                  label="App ready to publish"
                />
              </FormGroup>
            </MDBox>

            {goingToLive && (
              <>
                <hr />
                <MDBox
                  mt={2}
                  mb={2}
                  ml={0}
                  display="flex"
                  alignItems="start"
                  flexDirection="column"
                >
                  <MDTypography
                    variant="button"
                    sx={{ fontSize: '14px', fontWeight: '500' }}
                    mb={1}
                  >
                    App Images
                  </MDTypography>
                  <Stack direction="row" alignItems="center" spacing={2}>
                    <Button variant="contained" component="label" sx={{ color: '#fff' }}>
                      Upload Image +
                      <input hidden name="image" type="file" />
                    </Button>
                  </Stack>
                </MDBox>
                <MDBox>
                  <MDTypography
                    variant="button"
                    sx={{ fontSize: '14px', fontWeight: '500' }}
                    mb={1}
                  >
                    App Id
                  </MDTypography>
                  <MDInput
                    label="App Id"
                    defaultValue={data?.app_id}
                    placeholder="App Id"
                    name="app_id"
                    fullWidth
                  />
                </MDBox>
                <MDBox>
                  <MDTypography
                    variant="button"
                    sx={{ fontSize: '14px', fontWeight: '500' }}
                    mb={1}
                  >
                    Client Id
                  </MDTypography>
                  <MDInput
                    label="Client Id"
                    defaultValue={data?.client_id}
                    placeholder="Client Id"
                    name="client_id"
                    fullWidth
                  />
                </MDBox>
                <MDBox>
                  <MDTypography
                    variant="button"
                    sx={{ fontSize: '14px', fontWeight: '500' }}
                    mb={1}
                  >
                    Client Secret
                  </MDTypography>
                  <MDInput
                    label="Client Secret"
                    placeholder="Client Secret"
                    name="client_secret"
                    defaultValue={data?.client_secret}
                    fullWidth
                  />
                </MDBox>
                <MDBox>
                  <MDTypography
                    variant="button"
                    sx={{ fontSize: '14px', fontWeight: '500' }}
                    mb={1}
                  >
                    SSO Key
                  </MDTypography>
                  <MDInput
                    label="SSO Key"
                    placeholder="SSO Key"
                    name="sso"
                    defaultValue={data?.sso}
                    fullWidth
                  />
                </MDBox>
              </>
            )}
            {/* <MDBox>
              <MDTypography variant="button" sx={{ fontSize: '14px', fontWeight: '500' }} mb={1}>
                Monthly Plan ID
              </MDTypography>
              <MDInput
                label="Monthly Plan ID"
                placeholder="Monthly Plan ID"
                name="monthly_id"
                defaultValue={data?.monthly_id}
                fullWidth
              />
            </MDBox>

            <MDBox>
              <MDTypography variant="button" sx={{ fontSize: '14px', fontWeight: '500' }} mb={1}>
                Monthly Plan Price
              </MDTypography>
              <MDInput
                label="Monthly Plan Price"
                placeholder="Monthly Plan Price"
                name="monthly_price"
                type="number"
                defaultValue={data?.monthly_price}
                fullWidth
              />
            </MDBox>
            <MDBox>
              <MDTypography variant="button" sx={{ fontSize: '14px', fontWeight: '500' }} mb={1}>
                Yearly Plan ID
              </MDTypography>
              <MDInput
                label="Yearly Plan ID"
                placeholder="Yearly Plan ID"
                name="yearly_id"
                defaultValue={data?.yearly_id}
                fullWidth
              />
            </MDBox>

            <MDBox>
              <MDTypography variant="button" sx={{ fontSize: '14px', fontWeight: '500' }} mb={1}>
                Yearly Plan Price
              </MDTypography>
              <MDInput
                label="Yearly Plan Price"
                placeholder="Yearly Plan Price"
                name="yearly_price"
                type="number"
                defaultValue={data?.yearly_price}
                fullWidth
              />
            </MDBox> */}
            {/* new */}
            {/* <MDBox sx={{ fontSize: '15px' }}>
              <MDTypography variant="button" sx={{ fontSize: '14px', fontWeight: '500' }} mb={1}>
                Integration Type
              </MDTypography>
              <Multiselect
                data={integration_type}
                edit_data={data.integrationType}
                isMulti={false}
                name="integration_type"
              />
            </MDBox> */}
            {/* {IN()} */}
            {/* /// */}
            <MDBox display="flex" justifyContent="flex-end">
              <MDButton
                variant="gradient"
                color="primary"
                type="button"
                sx={{ mt: 4, mb: 1 }}
                onClick={closeAddProduct}
              >
                close
              </MDButton>
              <MDButton
                variant="gradient"
                color="info"
                type="submit"
                sx={{ mt: 4, mb: 1, ml: 1 }}
                loading={processing}
                disabled={processing}
              >
                Update
              </MDButton>
            </MDBox>
          </MDBox>
        </MDBox>
      </MDModal>
    )
  }
  const closeAddProduct = () => {
    // if (subscription?._id)
    setOpenAddProduct(false)
  }
  return (
    <>
      <MDButton
        size="small"
        sx={{ marginRight: 2 }}
        color="info"
        variant="contained"
        onClick={handlemodal}
      >
        Edit
      </MDButton>
      <AddProduct open={openAddProduct} onClose={closeAddProduct} />
    </>
  )
}

export default EditModal
